import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const DomainManagementPage: React.FC = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Domain Management Solutions | AquarLabs</title>
                <meta name="description" content="Manage your digital identity with AquarLabs' domain management solutions. Domain registration, portfolio management, and brand protection services." />
            </Helmet>
            <div className="about-page inner-page">
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Domain Management" pagesub="Domain Management" parentPage="Solutions" parentLink="/service" />
                        <section className="service-hero-section" style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.8) 100%)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h1 style={{ fontSize: "3rem", marginBottom: "20px", color: "#fff" }}>Domain Management</h1>
                                        <p style={{ fontSize: "1.25rem", color: "rgba(255,255,255,0.8)", lineHeight: "1.8" }}>
                                            Protect and manage your digital presence with comprehensive domain solutions. From registration to portfolio management, we help you secure your brand online.
                                        </p>
                                        <Link to="/contact-us" className="thm-btn agency-btn" style={{ marginTop: "30px", display: "inline-block" }}>
                                            <span className="text">Get Started</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section style={{ padding: "80px 0" }}>
                            <div className="container">
                                <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Overview</span>
                                <h2 style={{ fontSize: "2.5rem", margin: "15px 0 30px", color: "#fff" }}>Enterprise Domain Solutions</h2>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)" }}>
                                    AquarLabs provides complete domain lifecycle management—from initial registration across 500+ TLDs to ongoing portfolio management and brand protection. Our platform centralizes control, automates renewals, and protects against domain-related threats.
                                </p>
                            </div>
                        </section>
                        <section style={{ padding: "80px 0", background: "rgba(0,2,15,0.3)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase" }}>Capabilities</span>
                                        <h2 style={{ fontSize: "2rem", margin: "15px 0", color: "#fff" }}>Complete Domain Services</h2>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="row">
                                            {[
                                                { title: "Domain Registration", desc: "Register domains across 500+ TLDs with competitive pricing." },
                                                { title: "Portfolio Management", desc: "Centralized dashboard for all your domains with auto-renewal." },
                                                { title: "Brand Protection", desc: "Monitor for typosquatting and unauthorized domain use." },
                                                { title: "Transfer & Migration", desc: "Seamless domain transfers with zero downtime." }
                                            ].map((item, index) => (
                                                <div key={index} className="col-md-6" style={{ marginBottom: "30px" }}>
                                                    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", padding: "30px", height: "100%" }}>
                                                        <h3 style={{ fontSize: "1.25rem", color: "#fff", marginBottom: "15px" }}><span style={{ color: "#fc9038" }}>●</span> {item.title}</h3>
                                                        <p style={{ fontSize: "0.95rem", color: "rgba(255,255,255,0.7)" }}>{item.desc}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.5) 100%)" }}>
                            <div className="container text-center">
                                <h2 style={{ fontSize: "2.5rem", color: "#fff", marginBottom: "20px" }}>Secure Your Digital Identity</h2>
                                <Link to="/contact-us" className="thm-btn agency-btn"><span className="text">Contact Us Today</span></Link>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default DomainManagementPage;
